import React, { useEffect, useState } from "react";
import Div from "../../div";
import NavigateBanner from "../../common/navigate-banner";
import ContentWebContact from "./ContentWebContact";
import { Empty } from "antd";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { getAllNews, getNew } from "../../../api/news/api";
import { getProduct } from "../../../api/product/api";
import { getService } from "../../../api/service/api";
import { getCustomerDocument } from "../../../api/customer-documents/api";

function ContentWeb() {
  const [content, setContent] = useState();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const contenId = searchParams.get("content");
  const type = searchParams.get("type");
  const [data, setData] = useState([]);
  
  if (content?.name?.includes("/")) {
    navigate("/404");
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (contenId) {
      if (type === "news") {
        getNew(contenId)
          .then((res) => setContent(res?.data))
          .catch((error) => {
            console.log("erro", error);
          });
          getAllNews()
          .then((res) => {
            const data = res.data;
            data && setData(data);
          })
          .catch((err) => console.log(err));
      } else if (type === "product") {
        getProduct(contenId).then((res) => setContent(res.data));
      } else if (type === "dental-service") {
        getService(contenId).then((res) => setContent(res.data));
      } else if (type === "customer") {
        getCustomerDocument(contenId).then((res) => setContent(res.data));
      }
    }
  }, [type, contenId]);

  return (
    <Div>
      <section>
        {type === "product" ? (
          <NavigateBanner
            parentPage={"Sản phẩm"}
            navigatePage={content?.name}
          />
        ) : type === "dental" ? (
          <NavigateBanner parentPage={"Dịch vụ"} navigatePage={content?.name} />
        ) : type === "news" ? (
          <NavigateBanner parentPage={"Tin tức"} navigatePage={content?.name} />
        ) : (
          <NavigateBanner
            parentPage={"Khách hàng"}
            navigatePage={content?.name}
          />
        )}
      </section>

      <Div className="flex my-container">
        <section>
          {content ? (
            <Div className="pt-[50px] pb-[10px]">
              <Div>
                <Div>
                  <h1 className="text-4xl text-p-color font-bold mb-[25px]">
                    {content?.name}
                  </h1>
                </Div>

                <Div key={contenId} className="flex">
                  <Div>
                    <p className="text-2xl font-semibold text-p-color mb-[20px]">
                      {content?.name}
                    </p>

                    <Div
                      key={contenId}
                      dangerouslySetInnerHTML={{ __html: content?.description }}
                    />
                  </Div>
                </Div>
              </Div>
            </Div>
          ) : (
            <Div className="my-container pt-[50px] pb-[30px]">
              <Div className="w-full h-[500px] flex items-center justify-center">
                <Empty
                  style={{ fontSize: "25px" }}
                  description={"Nội dung hiện đang được cập nhật"}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </Div>
            </Div>
          )}
        </section>
        {type === "news" && (
          <Div className="px-[10px] pt-[50px] w-full h-[500px]">
            <Div>
              <p className="uppercase text-xs font-bold">Danh mục bài viết</p>
            </Div>
            <Div className="px-[10px] pt-[10px] w-full border-solid border border-slate-500">
              <ul className="flex flex-col gap-[15px]">
                {data.length > 0 &&
                  data.map((e, i) => {
                    return (
                      <li key={i} className="group">
                        <Div
                          onClick={() =>
                            navigate({
                              pathname: "/content-web",
                              search: `?${createSearchParams({
                                content: e.id,
                                type: "dental-service",
                              }).toString()}`,
                            })
                          }
                          className="flex items-center justify-between bg-white px-[5px] py-[12px] group-hover:bg-p-color group-hover:text-white duration-500"
                        >
                          <span>{e.name}</span>
                        </Div>
                      </li>
                    );
                  })}
              </ul>
            </Div>
          </Div>
        )}
      </Div>
      <section>
        <ContentWebContact />
      </section>
    </Div>
  );
}

export default ContentWeb;
